import { StockQuery, StockQueryVariables } from './__generated__/StockQuery';
import { useQuery } from 'react-apollo';
import * as query from './query.gql';

export const useProduct = (productId: number) => {
  const { data, loading } = useQuery<StockQuery, StockQueryVariables>(query, {
    variables: {
      id: productId,
    },
    errorPolicy: 'all',
  });

  return {
    loading,
    product: data?.stocksRemote.product,
  };
};
